import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import withAuthorization from '../../hoc/withAuthorization';
import LargePaper from '../../components/Layout/LargePaper';
import stylesDefault from '../../constants/stylesDefault';
import EditRenterForm from '../../components/Renter/EditRenterForm';

export class EditRenterPage extends Component {

    render() {
      return (
        <LargePaper>
          <h1 style={stylesDefault.title}>Éditer un loueur</h1>
          <EditRenterForm
            history={this.props.history}
            match={this.props.match}
          />
        </LargePaper>
      );
    }
}

const authCondition = authUser => !!authUser;


export default withAuthorization(authCondition)(withRouter(EditRenterPage));



// WEBPACK FOOTER //
// ./src/containers/EditRenterPage/EditRenterPage.jsx